import { useSyncExternalStore } from "react";

let state = { open: false, unreadCount: 0, failed: false };
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return state;
}

function setState(next: typeof state) {
  state = next;
  for (const listener of listeners) listener();
}

function show() {
  if (state.open) return;
  setState({ ...state, open: true });
}

function close() {
  if (!state.open) return;
  setState({ ...state, open: false });
}

function setUnreadCount(count: number) {
  if (state.unreadCount === count) return;
  setState({ ...state, unreadCount: count });
}

function setFailed(failed: boolean) {
  if (state.failed === failed) return;
  setState({ ...state, failed });
}

export function useIntercomMessenger() {
  const { open, unreadCount, failed } = useSyncExternalStore(
    subscribe,
    getSnapshot
  );
  return { open, unreadCount, failed, show, close, setUnreadCount, setFailed };
}
